import { createSimpleCRUDEntity } from '../crud-factory';

// Doctor Entity (simple, no transformations)
export const Doctor = createSimpleCRUDEntity('doctors');
